import { FC, MouseEvent, PropsWithChildren } from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@wellesley/ui'

type PreviewLabelProps = VariantProps<typeof labelVariants> &
  PropsWithChildren<{
    position: VariantProps<typeof labelVariants>
    className?: string
    onClick?: (e: MouseEvent<HTMLDivElement>) => void
    testId?: string
    isActive?: boolean
  }>

const labelVariants = cva(
  'absolute p-xxxs rounded-md text-white text-sm font-medium z-[1] backdrop-blur-[3px] bg-alpha-black-30 flex justify-center items-center',
  {
    variants: {
      position: {
        static: 'static',
        'top-left': 'top-xs left-xs',
        'top-right': 'top-xs right-xs',
        'top-right2': 'top-xs right-[52px]',
        'top-right3': 'top-[52px] right-xs',
        'bottom-left': 'bottom-xs left-xs',
        'bottom-right': 'bottom-xs right-xs',
      },
    },
  },
)

const PreviewLabel: FC<PreviewLabelProps> = ({
  isActive,
  onClick,
  position,
  testId = 'previewLabel',
  children,
  className,
}) => {
  return (
    <div
      data-testid={testId}
      onClick={onClick}
      className={cn(
        labelVariants({ position }),
        `${onClick ? 'cursor-pointer' : ''}`,
        isActive && 'border border-white ring-2 ring-[rgba(15,23,42,0.30)]',
        className,
      )}
    >
      {children}
    </div>
  )
}

export default PreviewLabel
